import { useQuery } from '@tanstack/react-query'
import { apiUrl, getHttpInit } from 'src/utils/api'
import { MS_TIME } from 'src/utils/timeUtils'

/**
 * `useQuery` wrapper for region-based links. E.g., charity and FAQ links.
 * @param {Object} params
 * @param {string} params.region
 * @param {string} params.endpoint
 * @param {string} params.queryKey
 * @returns
 */
const useRegionBasedLinkQuery = ({ region, endpoint, queryKey }) =>
  useQuery({
    enabled: !!region,
    retry: false,
    staleTime: MS_TIME.FIVE_MIN,
    gcTime: MS_TIME.FIVE_MIN,
    queryKey: [queryKey, region],
    queryFn: async () => {
      const response = await fetch(apiUrl(endpoint, { region }), getHttpInit('GET'))

      return response.ok ? response.json() : undefined
    },
    select: (data) => {
      if (data?.Response === 'Success') {
        /** @type {string} */
        const link = data?.Content?.Result?.link || ''

        localStorage.setItem(queryKey, link)

        return { url: link }
      }
    },
  })

export default useRegionBasedLinkQuery
